// extracted by mini-css-extract-plugin
export default {"header":"Convos_header__Oilq1","subheader":"Convos_subheader__fPFIV"};